// BNB Address
const BNB_ADDRESS = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c'
const WALL_ADDRESS = '0x2da2b8f961F161ab6320acB3377e2e844a3C3ce4'
const WETH_ADDRESS = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'
export { BNB_ADDRESS, WALL_ADDRESS, WETH_ADDRESS }
